{
  "appName": "Mock Form with Prefill",
  "entryFile": "./app-entry.jsx",
  "entryName": "mock-form-prefill",
  "rootUrl": "/mock-form-prefill",
  "productId": "0290e36a-cd62-47db-ba4a-32af2ee7ae37"
}
